import { Login } from "@/components/features/login/Login/Login";
import { AuthLayout } from "@/components/shared/layouts/AuthLayout/AuthLayout";

const LoginPage = () => {
  return (
    <AuthLayout>
      <Login />
    </AuthLayout>
  );
};

export default LoginPage;
